import type { PublicNavContext } from "../publicNavigation";
import type { NavConfig } from "./types";

export function getSignupCtaNavConfig(
  ctx: PublicNavContext,
): NavConfig["signupCta"] {
  const { isSwedish, destinations } = ctx;
  return {
    label: destinations.navAuthLabel(isSwedish ? "sv" : "en"),
    href: destinations.signInHref,
  };
}
